import React, { useEffect, useState } from "react";
import API from "../../../api/API";
import Authentication from "../../../api/Authentication/Authentication";

const UserSelectModal = ({ item, onCancel, onConfirm }) => {
  const [users, setUsers] = useState([]);
  const [selected, setSelected] = useState([]);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const currentUser = Authentication.getCurrentUser();
        const res = await API.getAllEnabledUsers(currentUser._id, currentUser.token);
        const userList = res.data.data || [];
        
        setSelected(item.sharedWith);

        // Exclude the current user from the selection list
        setUsers(userList.filter(u => u._id !== currentUser._id));
      } catch (err) {
        console.error("Failed to fetch users:", err);
      }
    };
    fetchUsers();
  }, [item]);

  const toggleSelection = (userId) => {
    setSelected(prev =>
      prev.includes(userId)
        ? prev.filter(id => id !== userId)
        : [...prev, userId]
    );
  };

  const handleConfirm = () => {
    onConfirm(selected);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div className="bg-white dark:bg-gray-800 p-6 rounded shadow-lg w-[400px] max-h-[80vh] overflow-y-auto">
        <h2 className="text-xl font-bold dark:text-white mb-4">Share with Users</h2>

        <ul className="mb-4">
          {users.map(user => (
            <li key={user._id} className="flex items-center mb-2">
              <input
                type="checkbox"
                id={`user-${user._id}`}
                checked={selected.includes(user._id)}
                onChange={() => toggleSelection(user._id)}
                className="mr-2"
              />
              <label htmlFor={`user-${user._id}`} className="dark:text-gray-200">{user.username}</label>
            </li>
          ))}
        </ul>

        <div className="flex justify-end space-x-3">
          <button
            onClick={onCancel}
            className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
          >
            Cancel
          </button>
          <button
            onClick={handleConfirm}
            className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 disabled:opacity-50"
          >
            Share
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserSelectModal;